export default {
    CloudLearningPaths: 'https://appwiki.xom.cloud/docs/admin/gettingstarted/LearningPaths.html?q=learning-paths-build',
    RequestConsultation: 'https://goto/AppConsult',
    SubscriptionBasics: 'https://appwiki.xom.cloud/docs/admin/gettingstarted/SubscriptionBasics.html',
    SubscriptionOwnerLearningPath: 'https://goto/CSOLP',
}